import axios from "axios";
const URLS = "https://plasticsmartcities.wwf.id/aksi/api";
var TOKEN = sessionStorage.getItem('token');


export default {
   actions: {
      setToken(data){
         TOKEN = data
      },
      get_province() {
         return new Promise((resolve, reject) => {
         try {
            axios
               .get(URLS + `/indonesia/provinces`)
               .then((response) => {
               resolve(response?.data);
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_cities(prov) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .get(URLS + `/indonesia/cities` + '?province_code=' + prov)
               .then((response) => {
               resolve(response?.data);
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_district(city) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .get(URLS + `/indonesia/districts` + '?city_code=' + city)
               .then((response) => {
               resolve(response?.data);
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_village(dst) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .get(URLS + `/indonesia/villages` + '?district_code=' + dst)
               .then((response) => {
               resolve(response?.data);
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_partner(url = '') {
         return new Promise((resolve, reject) => {
         const defaultUrl = URLS + `/v1/partner`;
         try {
            axios
               .get(defaultUrl+url)
               .then((response) => {
               resolve(response?.data?.data);
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_notification() {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/notification`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*'
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      post_read_notification(id) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/notification/${id}`,{}, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*'
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
   },
};